const ITEMS = ["Pressure washing", "Soft house wash", "Gutter cleaning", "Solar panels", "Black spot removal", "Window cleaning", "Drain unblocking", "Glass & mirror", "Bin cleaning", "Bendigo & surrounds"];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS.map((t) => ({ t, k: `a-${t}` })), ...ITEMS.map((t) => ({ t, k: `b-${t}` }))];
  return (
    <div data-testid="marquee-banner" className={`relative overflow-hidden border-y ${dark ? "bg-ink border-white/10" : "bg-brand border-brand"} py-4 sm:py-5 select-none`}>
      <div className="flex w-max animate-marquee will-change-transform">
        {row.map(({ t, k }) => (
          <span key={k} className={`flex items-center gap-6 sm:gap-8 pr-6 sm:pr-8 font-display font-black uppercase tracking-tight text-2xl sm:text-4xl whitespace-nowrap ${dark ? "text-white/90" : "text-white"}`}>
            {t}
            <span className={`w-2.5 h-2.5 rounded-full ${dark ? "bg-brand-light" : "bg-brand-light"}`} />
          </span>
        ))}
      </div>
    </div>
  );
};
